<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="title-md" i18n>Affected Accounts</div>
    <div class="d-flex flex-column gap-2">
      <div class="hint">{{ sectionLabel }}</div>
      <div class="flex-grow-1">
        <app-investment-instruction-submission-affected-account-list-item
          *ngFor="let account of affectedAccounts; let last = last; trackBy: trackByAccountId"
          [affectedAccount]="account"
          [lastInList]="last"
          [accountType]="accountType"
          (viewAccountClicked)="viewAccountClicked.emit(account)" />
      </div>
    </div>
  </div>
</div>
